<script setup>
import { useTokenTransactionDownloads } from "@/composables/useTokenTransactionDownloads.js";
import { computed } from "vue";

const {
    loadingDownload,
    loadingDownloadSelected,
    download,
    downloadAllConfirmations,
    downloadSelectedConfirmations,
} = useTokenTransactionDownloads();

const props = defineProps({
    filters: {},
    companyId: {required: false},
    total: {},
    selectedIds: {},
    selectionMode: {type: Boolean},
    administrationTransactions: {type: Boolean, default: false},
})

const emits = defineEmits(['onChangeSelectionMode']);

const toggleSelectionMode = () => {
    emits('onChangeSelectionMode');
}

const selectedCount = computed(() => props.selectedIds.length)

</script>

<template>
    <div class="mb-4 is-flex is-flex-wrap-wrap download-buttons">
        <b-button type="is-link"
                  :class="{ 'is-loading': loadingDownload }"
                  @click="downloadAllConfirmations(filters, companyId, administrationTransactions)"
        >
            {{ $t('token_transactions.actions.download_all_confirmations') }} <span v-if="total">({{ total }})</span>
        </b-button>

        <b-button
            :type="selectionMode ? 'is-warning' : 'is-light'"
            icon-left="checkbox-multiple-marked-outline"
            @click="toggleSelectionMode"
        >
            {{ selectionMode ? $t('token_transactions.actions.cancel_selection') : $t('token_transactions.actions.select_transactions') }}
        </b-button>

        <template v-if="selectionMode">
            <b-button
                type="is-success"
                icon-left="file-download-outline"
                :class="{ 'is-loading': loadingDownloadSelected }"
                :disabled="selectedCount === 0 || loadingDownloadSelected"
                @click="downloadSelectedConfirmations(selectedIds, administrationTransactions)"
            >
                {{ $t('token_transactions.actions.download_selected_confirmations') }}
                <span v-if="selectedCount > 0">({{ selectedCount }})</span>
            </b-button>
        </template>
    </div>
</template>

<style scoped>
.download-buttons {
    gap: 0.5rem;
    align-items: center;
}
</style>
